import React from 'react';
import { QboCard, QboCardCaption } from '@ui/Components';
import NoReplicateStatus from '@images/generals/NoReplicateStatus.svg';
import { useTranslation } from 'react-i18next';

export default function NoReplicateSection() {
  const { t } = useTranslation();

  return (
    <QboCard noPadding isMainWrapper>
      <QboCardCaption
        imageUrl={NoReplicateStatus}
        heading={t('status_replicate_page.no_replicate_section.heading_text')}
        caption={t('status_replicate_page.no_replicate_section.caption_text')}
      />
    </QboCard>
  );
}
